import { constants } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { FC, memo } from 'react';
import { useDispatch } from 'react-redux';

import { removeAttachment, uploadAttachments } from '../../../../../actions';
import FileDropProvider from '../../../../../components/FileDropProvider';
import FileList from '../../../../../components/filesSection/FileList/FileList';
import RequestFormSection from '../../../../../components/RequestFormSection/RequestFormSection';
import { AttachmentKind } from '../../../../../data/AttachmentKind';
import { getContext, getNewAttachments, getRequest } from '../../../../../selectors/pageSelectors';
import { messages } from './Files.messages';

const { qBooksConstants } = constants;

interface FilesProps {
    className?: string;
}

/**
 * @deprecated Use AttachmentsSection
 */
const Files: FC<FilesProps> = (props) => {
    const { className } = props;

    const context = useSelector(getContext);
    const { attachments, newAttachments } = useSelector((state) => {
        return {
            attachments: getRequest(state).attachments,

            newAttachments: getNewAttachments(state),
        };
    });

    const dispatch = useDispatch();

    return (
        <RequestFormSection header={messages.filesHeader} className={className}>
            <FileDropProvider
                onUpload={(files, attachmentKind) => {
                    dispatch(uploadAttachments({ files, attachmentKind }));
                }}
                maxSize={context?.attachmentMaxSize}
                allowedFileExtensions={qBooksConstants.QBO_ALLOWED_FILE_EXTENSIONS}
            >
                <FileList
                    attachments={attachments}
                    newAttachments={newAttachments}
                    removeAttachment={(attachmentId: string) => dispatch(removeAttachment(attachmentId))}
                    attachmentKind={AttachmentKind.General}
                />
            </FileDropProvider>
        </RequestFormSection>
    );
};

export default memo(Files);
